import { Caption } from '@telegram-apps/telegram-ui';

type ActivityDayHeaderProps = {
    displayDate: string;
};

export const ActivityDayHeader = ({ displayDate }: ActivityDayHeaderProps) => {
    return <Caption style={{ color: 'var(--tg-theme-hint-color)', fontSize: 12, fontWeight: 700, lineHeight: 1.2 }}>{displayDate}</Caption>;
};
